import { ReactNode } from 'react';
import {
  CATEGORIES_PATH,
  CATEGORY_PATH,
  MATERIAL_PATH,
  SEARCH_PATH,
  SUBCATEGORY_PATH,
} from '@/_constants/routes';

const ROUTES_WITH_CATEGORY_TREE = [
  CATEGORIES_PATH,
  CATEGORY_PATH,
  SUBCATEGORY_PATH,
  MATERIAL_PATH,
  SEARCH_PATH,
];

export const getCategoryTree = (
  pathname: string,
  categoryTree: ReactNode,
): ReactNode | undefined => {
  const isVisible = ROUTES_WITH_CATEGORY_TREE.some((route) =>
    pathname.includes(route),
  );

  return isVisible ? categoryTree : undefined;
};
